import { IonSpinner } from '@ionic/react';
import React from 'react';
import styles from './styles.module.scss';

const Spinner = ({type='dots', color='secondary'}:{type?:'dots' | 'bubbles' | 'circles' | 'circular' | 'crescent' | 'lines' | 'lines-small' | 'lines-sharp' | 'lines-sharp-small', color?:string}) => {
  return (
    <div className={styles.wrapper}>
      {/* https://ionicframework.com/docs/api/spinner */}
      <IonSpinner className={styles.spinner} name={type} color={color}></IonSpinner>
    </div>
  );
};

export default Spinner;